export enum ENotificationType {
    update = 0
}